var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('span',{staticClass:"d-block"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.text)?_c('small',{staticClass:"d-block"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }